var map = {
	"./data-center.gif": "f934",
	"./scervice-10.gif": "5a5b",
	"./scervice-11.gif": "5251",
	"./service-12.gif": "f361",
	"./service-14.gif": "8f8c",
	"./service-2.gif": "816a",
	"./service-4.gif": "3e15",
	"./service-6.gif": "9151",
	"./service-7.gif": "25e8",
	"./service-8.gif": "7322",
	"./service-9.gif": "ea74",
	"./sevice-1.gif": "6b91"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3409";